export default {
  methods: {
    getUserAcls() {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user || user.moreInfo == undefined || user.moreInfo == null) {
        return [];
      }

      try {
        return JSON.parse(window.atob(user.moreInfo));
      } catch (error) {
        return [];
      }
    },
    can(alias) {
      const acls = this.getUserAcls();
      return acls.find((acl) => acl === alias);
    },
  },
};
